import MaterialBuilder from "../rendering/material-builder";
import AssetLibrary from "../assets/asset-library";

const mapArray = ['map', 'aoMap', 'bumpMap', 'normalMap', 'alphaMap', 'lightMap', 'emissiveMap', 'roughnessMap', 'metalnessMap'];

function initMaterial(mesh) {

    if (mesh.material instanceof Array) {
        let materials = mesh.material.map(initSingleMaterial);
        let matParams = materials.map(m => m.data);
        mesh.material = materials.map(m => m.material);
        return matParams;
    } else {
        let { data: matParams, material } = initSingleMaterial(mesh.material);
        mesh.material = material;
        return matParams;
    }

}

function initSingleMaterial(originalMaterial) {

    let tempMaterial = originalMaterial.clone();

    const groupUuid = originalMaterial.uuid;

    let newMaterial = MaterialBuilder.build({
        color: 0xffffff,
        morphTargets: originalMaterial.morphTargets,
        morphNormals: originalMaterial.morphNormals,
        skinning: originalMaterial.skinning
    });

    const matParams = {};

    //apply all available textures
    for (var i = 0; i < mapArray.length; i++) {
        const property = mapArray[i];
        if (tempMaterial[property]) {
            if (tempMaterial[property].image) {
                matParams[property] = tempMaterial[property].uuid;
            } if (tempMaterial[property].fileName) {
                matParams[property + '_fileName'] = tempMaterial[property].fileName;
            }
            newMaterial[property] = tempMaterial[property];
        }
    }

    matParams['opacity'] = tempMaterial.opacity;
    matParams['transparent'] = tempMaterial.transparent;
    matParams['color'] = '0x' + tempMaterial.color.getHexString();
    matParams['groupUuid'] = groupUuid;

    let name = tempMaterial.name;
    if (name !== '') {
        matParams.name = name;
        newMaterial.name = name;
    }

    if (tempMaterial.morphTargets !== undefined) matParams.morphTargets = tempMaterial.morphTargets;
    if (tempMaterial.morphNormals !== undefined) matParams.morphNormals = tempMaterial.morphNormals;
    if (tempMaterial.skinning !== undefined) matParams.skinning = tempMaterial.skinning;

    if (tempMaterial.side !== undefined) matParams['side'] = tempMaterial.side;
    if (tempMaterial.flatShading !== undefined) matParams['flatShading'] = tempMaterial.flatShading;
    if (tempMaterial.blending !== undefined) matParams['blending'] = tempMaterial.blending;
    if (tempMaterial.metalness !== undefined) matParams['metalness'] = tempMaterial.metalness;
    if (tempMaterial.roughness !== undefined) matParams['roughness'] = tempMaterial.roughness;
    if (tempMaterial.emissive !== undefined) matParams['emissive'] = '0x' + tempMaterial.emissive.getHexString();
    if (tempMaterial.emissiveIntensity !== undefined) matParams['emissiveIntensity'] = tempMaterial.emissiveIntensity;
    if (tempMaterial.envMapIntensity !== undefined) matParams['envMapIntensity'] = tempMaterial.envMapIntensity;

    const propertiesArray = ['groupUuid', 'transparent', 'opacity', 'bumpScale', 'normalScale', 'lightMapIntensity', 'aoMapIntensity', 'side', 'flatShading', 'blending', 'metalness', 'roughness', 'emissiveIntensity', 'envMapIntensity'];


    newMaterial.uuid = tempMaterial.uuid;
    newMaterial.color = tempMaterial.color;
    newMaterial.emissive = tempMaterial.emissive || new THREE.Color(0x000000);

    newMaterial.skinning = tempMaterial.skinning;

    propertiesArray.forEach(function (prop) {
        if (prop in matParams && prop in newMaterial) {
            newMaterial[prop] = matParams[prop];
        }
    });

    newMaterial.envMap = AssetLibrary.envLight.activeMap;

    if (newMaterial.transparent) newMaterial.alphaTest = 0.01;

    newMaterial.needsUpdate = true;

    return { data: matParams, material: newMaterial };

}

export default initMaterial;
export { initMaterial };